import * as actions from './map.actions'

const initialState = {
  userMap: {
    mapId: null,
    buildings: {},
    removedRocks: {},
    extraBuildings: {},
  },
  visitorMap: {
    mapId: null,
    buildings: {},
    removedRocks: {},
    visitorId: null,
  },
  sprites: {},
  backToRanking: false,
  selectedTile: null,
  displayingBuildingCard: 'windmill',
  zoomLevels: [20, 10], //,3]
  attackState: false,
}

const actionsMap = {
  [actions.SELECT_CURRENT_TILE]: (state, action) => {
    return {
      ...state,
      selectedTile: action.data,
    }
  },
  [actions.CLEAR_SPRITES]: (state) => {
    return {
      ...state,
      sprites: {},
    }
  },
  [actions.BACK_TO_RANKING]: (state, action) => {
    let backToRanking = action.data
    return {
      ...state,
      backToRanking: backToRanking,
    }
  },
  [actions.TOGGLE_ATTACK]: (state) => {
    return {
      ...state,
      attackState: !state.attackState,
    }
  },
  [actions.DISPLAYING_BUILDING_CARD]: (state, action) => {
    return {
      ...state,
      displayingBuildingCard: action.data,
    }
  },
  [actions.ADD_SPRITE]: (state, action) => {
    let sprite = action.data
    return {
      ...state,
      sprites: {
        ...state.sprites,
        [sprite.id]: {
          name: sprite.name,
          position: sprite.position,
          store: sprite.customStore,
        },
      },
    }
  },
  [actions.REMOVE_SPRITE]: (state, action) => {
    let sprites = { ...state.sprites }
    delete sprites[action.data]

    return {
      ...state,
      sprites: sprites,
    }
  },
  [actions.SET_USER_MAP]: (state, action) => {
    return {
      ...state,
      userMap: {
        ...state.userMap,
        ...action.data,
      },
    }
  },
  [actions.DELETE_BUILDING]: (state, action) => {
    const buildingKey = action.data

    let buildings = {
      ...state.userMap.buildings,
    }

    delete buildings[buildingKey]
    const userMap = {
      ...state.userMap,
      buildings,
    }
    return {
      ...state,
      userMap: userMap,
    }
  },
  [actions.DELETE_EXTRA_BUILDING]: (state, action) => {
    const buildingKey = action.data

    let extraBuildings = {
      ...state.userMap.extraBuildings,
    }

    delete extraBuildings[buildingKey]
    const userMap = {
      ...state.userMap,
      extraBuildings,
    }
    return {
      ...state,
      userMap: userMap,
    }
  },
  [actions.DELETE_VISITOR_BUILDING]: (state, action) => {
    const buildingKey = action.data

    let buildings = {
      ...state.visitorMap.buildings,
    }

    delete buildings[buildingKey]
    const visitorMap = {
      ...state.visitorMap,
      buildings,
    }
    return {
      ...state,
      visitorMap: visitorMap,
    }
  },
  [actions.SET_VISITOR_MAP]: (state, action) => {
    return {
      ...state,
      visitorMap: {
        ...state.visitorMap,
        ...action.data,
      },
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
